import React, { useState } from 'react';

export default function CopyInviteLinkButton({ url, className = '' }) {
  const [copied, setCopied] = useState(false);

  if (!url) return null;

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(url);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch {
      window.prompt('Copy invite link', url);
    }
  };

  return (
    <button
      type="button"
      onClick={handleCopy}
      className={className || 'text-blue-600 hover:text-blue-800 text-xs font-medium'}
    >
      {copied ? 'Copied' : 'Copy invite link'}
    </button>
  );
}
